import ConstituentSearchColumn from '@/constants/ConstituentSearchColumn';

const SocialMediaColumnOptions = [
  ConstituentSearchColumn.INSTAGRAM,
  ConstituentSearchColumn.TWITTER,
  ConstituentSearchColumn.LINKEDIN,
  ConstituentSearchColumn.FACEBOOK,
  ConstituentSearchColumn.YOUTUBE,
  ConstituentSearchColumn.TIKTOK,
];

export default SocialMediaColumnOptions;
